<div class="wrapper wrapper-full-page">
  <div class="page-header login-page header-filter">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5">
          <form [formGroup]="form">
            <mat-card>
              <mat-card-content>
                  <div class="text-center mb-1 mt-1">
                    <img src="/assets/img/logo-logimaps.png">
                  </div>
                  <h1 class="mat-display-1 text-center">Logovanje</h1>
                  <mat-form-field appearance="outline">
                    <mat-label>Korisničko ime*</mat-label>
                    <input matInput formControlName="username" placeholder="korisnik">
                    <mat-icon matSuffix [class.invalid]="isFormControlTouched(form.controls['username'])">perm_identity</mat-icon>
                    <mat-error *ngIf="form.invalid">{{ getErrorMessage(form.controls['username']) }}</mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Lozinka*</mat-label>
                    <input matInput formControlName="password" type="password">
                    <mat-icon matSuffix [class.invalid]="isFormControlTouched(form.controls['password'])">verified_user</mat-icon>
                    <mat-error *ngIf="form.invalid">{{ getErrorMessage(form.controls['password']) }}</mat-error>
                  </mat-form-field>
                  <div class="form-group text-center">
                    <span class="forgot-password" (click)="openDialog()">
                      Zaboravljena lozinka?
                    </span>
                  </div>
                <div class="form-group">
                  <button mat-button class="default-button-color" type="submit" [disabled]="form.invalid" (click)="login()">Uloguj se</button>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
